module.exports = __webpack_public_path__ + "static/media/revolugo.5c641bc7.png";